import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import Container from './Container'
import Typography from 'material-ui/Typography'
import SentimentDissatifiedIcon from 'material-ui-icons/SentimentDissatisfied'

const styles = () => ({
  VBErrorMessageWrapper: {
    marginTop: 50,
    textAlign: 'center'
  },
  VBErrorMessageIcon: {
    width: 40,
    height: 40,
    position: 'relative',
    top: 8
  },
})

const ErrorMessage = ({classes, error}) => {
  return (
    <Container>
      <div className={classes.VBErrorMessageWrapper}>
        <Typography variant="display2">{error} <SentimentDissatifiedIcon className={classes.VBErrorMessageIcon}/></Typography>
      </div>
    </Container>
  )
}

ErrorMessage.propTypes = {
  error: PropTypes.string.isRequired,
}

export default withStyles(styles)(ErrorMessage)



// WEBPACK FOOTER //
// ./src/common/components/ErrorMessage.js